import { BRAND, brandUrl } from './brand'

const defaultDescription =
  'Noor is your health companion for everyday mental and physical wellbeing. Daily check-ins, guided lessons, sleep improvement, fitness tracking, and water tracking in one calm app.'

/** Per-route SEO titles, descriptions, and breadcrumb labels for document + structured data. */
export const PAGE_SEO = {
  '/': {
    title: `${BRAND.appName} - ${BRAND.tagline}`,
    description: defaultDescription,
    breadcrumb: [{ name: 'Home', path: '/' }],
  },
  '/features': {
    title: `${BRAND.appName} features - daily check-ins, lessons, sleep, fitness & water`,
    description:
      'Explore Noor features: daily mental health check-ins, guided lesson paths, sleep improvement tools, fitness routines, and water tracking in one wellness app.',
    breadcrumb: [
      { name: 'Home', path: '/' },
      { name: 'Features', path: '/features' },
    ],
  },
  '/contact': {
    title: `Contact ${BRAND.appName} - support and account help`,
    description: `Questions, billing help, or account support for ${BRAND.appName}? Email ${BRAND.email.support} or use the contact form on noorhc.app.`,
    breadcrumb: [
      { name: 'Home', path: '/' },
      { name: 'Contact', path: '/contact' },
    ],
  },
  '/Contactus': {
    title: `Contact ${BRAND.appName} - support and account help`,
    description: `Questions, billing help, or account support for ${BRAND.appName}? Email ${BRAND.email.support} or use the contact form on noorhc.app.`,
    breadcrumb: [
      { name: 'Home', path: '/' },
      { name: 'Contact', path: '/contact' },
    ],
  },
  '/aboutus': {
    title: `About ${BRAND.appName} - everyday health companion`,
    description:
      'Learn how Noor supports everyday mental and physical wellbeing with evidence-informed lessons, check-ins, sleep tools, fitness tracking, and water tracking.',
    breadcrumb: [
      { name: 'Home', path: '/' },
      { name: 'About', path: '/aboutus' },
    ],
  },
  '/privacy-policy': {
    title: `${BRAND.appName} privacy policy`,
    description: `Privacy policy for the ${BRAND.appName} wellness app and noorhc.app marketing site. How we collect, use, and protect your data.`,
    breadcrumb: [
      { name: 'Home', path: '/' },
      { name: 'Privacy Policy', path: '/privacy-policy' },
    ],
  },
  '/terms-of-use': {
    title: `${BRAND.appName} terms of use`,
    description: `Terms of use for the ${BRAND.appName} health companion app and noorhc.app website.`,
    breadcrumb: [
      { name: 'Home', path: '/' },
      { name: 'Terms of Use', path: '/terms-of-use' },
    ],
  },
  '/changelog': {
    title: `${BRAND.appName} changelog`,
    description: `Release notes and app updates for ${BRAND.appName}. See what is new in each version.`,
    breadcrumb: [
      { name: 'Home', path: '/' },
      { name: 'Changelog', path: '/changelog' },
    ],
  },
}

export const SEO_DEFAULTS = {
  siteName: BRAND.appName,
  description: defaultDescription,
  locale: 'en_GB',
  ogImagePath: '/hero_image.webp',
  ogImageAlt: 'Noor app: explore modules and daily wellbeing tools',
  ogImageWidth: 880,
  ogImageHeight: 471,
}

export function pageCanonicalUrl(pathname) {
  const base = brandUrl('marketing').replace(/\/$/, '')
  if (!pathname || pathname === '/') return `${base}/`
  return `${base}${pathname.startsWith('/') ? pathname : `/${pathname}`}`
}

export function pageSeoForPath(pathname) {
  return PAGE_SEO[pathname] ?? PAGE_SEO['/']
}
